import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Política de Privacidad" updated="2026" testid="page-privacidad">
      <P>En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y de la Ley Orgánica 3/2018, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), CYVR Labs informa sobre el tratamiento de los datos personales de los usuarios de <b>cyvrlabs.com</b>.</P>

      <H2>1. Responsable del tratamiento</H2>
      <UL>
        <li>Titular: CYVRLABS — Ciberseguridad, vulnerabilidades y trabajos de seguridad informática</li>
        <li>NIF: 40967909X</li>
        <li>Domicilio: Apartado de Correos 12345</li>
        <li>Correo electrónico: contacto@cyvrlabs.com</li>
      </UL>

      <H2>2. Datos que tratamos</H2>
      <UL>
        <li>Datos de contacto que facilitas en formularios (nombre, email, empresa, mensaje).</li>
        <li>Datos de cuenta si te registras (nombre, email y contraseña cifrada).</li>
        <li>Datos de facturación en caso de contratación de servicios (gestionados por el proveedor de pagos Stripe).</li>
        <li>Datos técnicos y de navegación (IP, dispositivo, cookies analíticas).</li>
      </UL>

      <H2>3. Finalidades y base jurídica</H2>
      <UL>
        <li>Atender solicitudes de contacto y presupuestos — base: consentimiento e interés legítimo.</li>
        <li>Gestionar tu cuenta y prestar los servicios contratados — base: ejecución de contrato.</li>
        <li>Cumplir obligaciones legales y fiscales — base: obligación legal.</li>
        <li>Analítica web y mejora del servicio — base: consentimiento (cookies).</li>
      </UL>

      <H2>4. Conservación</H2>
      <P>Conservamos los datos mientras exista relación con el usuario y, posteriormente, durante los plazos legalmente exigidos (p. ej., fiscales y de responsabilidad).</P>

      <H2>5. Destinatarios</H2>
      <P>No cedemos datos a terceros salvo obligación legal. Utilizamos encargados de tratamiento (proveedor de correo, pasarela de pago Stripe, analítica de Google) que cumplen el RGPD. Algunas transferencias internacionales se amparan en las cláusulas contractuales tipo de la UE.</P>

      <H2>6. Derechos</H2>
      <P>Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad, así como retirar el consentimiento, escribiendo a contacto@cyvrlabs.com. También puedes reclamar ante la Agencia Española de Protección de Datos (www.aepd.es).</P>

      <H2>7. Seguridad</H2>
      <P>Aplicamos medidas técnicas y organizativas apropiadas para proteger tus datos (cifrado de contraseñas, HTTPS y control de accesos).</P>
    </LegalLayout>
  );
}
